import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./utils/console.js";
import "@/components/Vant";
import "amfe-flexible";
// 地图
import BaiduMap from "vue-baidu-map";

Vue.use(ElementUI);
Vue.config.productionTip = false;
// SVjQqWYIoeoecUdYzGUy64yRYEHa8qV9  k6z8f1gX1K1YbvZQQWRmzKg23wiqhN71
// kKgabxgOQHufmyNPwENH1bLWm2Tsg3w0
Vue.use(BaiduMap, { ak: "K4Nw1sXjvOzelruZDGFMP9oyNyTBuB0p" });
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
